module.exports = __webpack_public_path__ + "static/img/nopushdata.efa2183.png";